export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-white pt-16 pb-24">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 lg:grid-cols-10 gap-12 mb-12">
          {/* Left - Brand */}
          <div className="lg:col-span-3">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-white">湧水堂</h3>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              船橋市の水回りリフォーム専門店。<br />
              技術と価格、そしてホスピタリティで<br />
              お客様の信頼にお応えします。
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#ff8c42] hover:text-[#ff8c42] transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#ff8c42] hover:text-[#ff8c42] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#ff8c42] hover:text-[#ff8c42] transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="https://line.me/R/ti/p/@example" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border-2 border-white/30 rounded-full flex items-center justify-center hover:border-[#ff8c42] hover:text-[#ff8c42] transition-colors cursor-pointer">
                <i className="ri-line-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Center - Contact Info */}
          <div className="lg:col-span-3 space-y-6">
            <div>
              <h4 className="text-sm font-bold text-gray-400 mb-3 uppercase tracking-wider">住所</h4>
              <p className="text-white">
                〒274-0065<br />
                千葉県船橋市高根台1-13-1-102
              </p>
            </div>
            <div>
              <h4 className="text-sm font-bold text-gray-400 mb-3 uppercase tracking-wider">電話</h4>
              <a href="tel:0474010700" className="text-white text-lg font-bold hover:text-[#ff8c42] transition-colors cursor-pointer">
                047-401-0700
              </a>
            </div>
            <div>
              <h4 className="text-sm font-bold text-gray-400 mb-3 uppercase tracking-wider">メール</h4>
              <a href="mailto:info@yusuidou.com" className="text-white hover:text-[#ff8c42] transition-colors cursor-pointer">
                info@yusuidou.com
              </a>
            </div>
          </div>

          {/* Right - Area */}
          <div className="lg:col-span-4">
            <div className="bg-white/5 rounded-xl p-4">
              <p className="text-sm text-gray-400 text-center mb-2">対応エリア</p>
              <p className="text-white font-bold text-center mb-3">船橋市全域</p>
              <div className="text-xs text-gray-400 leading-relaxed max-h-48 overflow-y-auto">
                旭町 / 東町 / 市場 / 印内 / 印内町 / 海神 / 海神町 / 海神町西・南・東 / 葛飾町 / 金杉 / 金杉台 / 金杉町 / 金堀町 / 上山町 / 北本町 / 行田 / 行田町 / 楠が山町 / 車方町 / 高野台 / 古作 / 古作町 / 小室町 / 栄町 / 咲が丘 / 潮見町 / 芝山 / 新高根 / 神保町 / 鈴身町 / 駿河台 / 高瀬町 / 高根台 / 高根町 / 滝台 / 滝台町 / 田喜野井 / 坪井町 / 坪井東 / 坪井西 / 豊富町 / 中野木 / 夏見 / 夏見台 / 夏見町 / 七林町 / 習志野 / 習志野台 / 西浦 / 西船 / 二宮 / 飯山満町 / 浜町 / 東船橋 / 日の出 / 藤原 / 二和東 / 二和西 / 本郷町 / 本中山 / 本町 / 前貝塚町 / 前原西 / 前原東 / 馬込町 / 馬込西 / 松が丘 / 丸山 / 三咲 / 三咲町 / 湊町 / 南海神 / 三山 / 宮本 / 八木が谷 / 八木が谷町 / 薬円台 / 薬園台町 / 山手 / 山中町 / 若松
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © 2025 船橋市ユニットバスリフォーム専門店. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-500">
              <a href="#" className="hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer">利用規約</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
